export const SET_USER = 'set-user';
export const SET_CLIENT_LOGO = 'set-client-logo';
export const SET_LANGUAGE = 'set-language';
export const SET_FONT_SIZE = 'set-font-size';
export const SET_APP_THEME = 'set-app-theme';
export const SET_INSTALLATION = 'set-installation';
export const SET_TOKEN = 'set-token';
export const SET_APP_CONFIGURATION = 'set-app-configuration';
export const SET_ERROR_GETTING_APP_CONFIGURATION = 'set-error-getting-app-configuration';
export const SET_PERMISSIONS = 'set-permission';
export const SET_TEMPORARY_ACCESS_DATA = 'set-temporary-access-data';
export const SET_RECOVER_DATA = 'set-recover-data';
export const SET_ACCESS_PENDING = 'set-access-pending';
export const REMOVE_ACCESS_PENDING = 'remove-access-pending';
export const CLEAR_ACCESS_PENDING = 'clear-access-pending';
export const SET_USER_ACCESSIBLE_INSTALLATION = 'set-user-accessible-installations';
export const SET_PRINTING_MODE = 'set-printing-mode';
export const SET_SIMULATION_DATA_POINTS = 'set-simulation-data-points';
export const SET_SIMULATION_DATA_IS_INVALID = 'set-simulation-data-is-invalid';
export const SET_SIMULATION_DATA_VALID_POINTS = 'set-simulation-data-valid-points';
export const SET_SIMULATION_DATA_IS_EMPTY = 'set-simulation-data-is-empty';
export const SET_SIMULATION_DATA_INTERVAL = 'set-simulation-data-interval';
export const SET_SIMULATION_DATA_IS_INTERVAL_INVALID = 'set-simulation-data-is-interval-invalid';
export const SET_SIMULATION_DATA_REPETITIONS = 'set-simulation-data-repetitions';
export const SET_SIMULATION_DATA_IS_REPETITIONS_INVALID = 'set-simulation-data-is-repetitions-invalid';
export const SET_SIMULATION_DATA_IMPORT_DATA = 'set-simulation-data-import-data';
export const SET_SUB_MENU_ITEMS = 'set-sub-menu-items';
export const SET_SUB_MENU_COLLAPSED = 'set-sub-menu-collapsed';
export const SET_ASSET_SUBMENU_ITEMS = 'set-asset-sub-menu-items';
export const SET_ASSET_SUBMENU = 'set-asset-sub-menu';
export const SET_SUB_MENU_ROUTE = 'set-sub-menu-route';
export const SET_NOTIFICATION = 'set-notification';
export const SET_ERROR_NOTIFICATION = 'set-error-notifications';
export const SET_REFRESH_TOKEN_EXPIRED = 'set-refresh-token-expired';
export const SET_REFRESH_TOKEN_EXPIRATION = 'set-refresh-token-expiration';
export const SET_API_UNREACHABLE = 'set-api-unreachable';

